/* Wanderest v7: smooth fade-in for page content (visual only) */
(function () {
  if (window.__wrFade) return; window.__wrFade = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;

  function run() {
    /* top of the page: gentle entrance on load */
    var top = document.querySelectorAll('.pdp__media, .pdp__info > *');
    Array.prototype.forEach.call(top, function (el, i) {
      if (i > 9) return;
      el.style.animationDelay = (i * 70) + 'ms';
      el.classList.add('wr-enter');
    });

    /* everything below: fade in while scrolling */
    var sel = [
      '.section:not(.pdp) .sec-head', '.mt__grid > *', '.mt__cta', '.rich__inner', '.rich__cta',
      '.reel', '.reels__cta', '.love-card', '.love__promise', '.love__cta',
      '.compare__table', '.guarantee__inner', '.reviews__app', '.review-card',
      '.faq__item', '.faq__contact', '.col-card'
    ].join(',');
    var els = document.querySelectorAll(sel);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var lastParent = null, n = 0;
    Array.prototype.forEach.call(els, function (el) {
      if (el.closest('.pdp') || el.classList.contains('reveal') || el.closest('.reveal')) return;
      if (el.parentNode !== lastParent) { lastParent = el.parentNode; n = 0; }
      el.style.transitionDelay = Math.min(n, 5) * 90 + 'ms';
      n++;
      el.classList.add('wr-fade');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
